import store from '../../redux/store';
import {
  selectSection,
  setIsMobile,
  setNavbarHeight,
  showHorizontalSection,
  showMessageModal,
  updateShopIsLoaded,
} from '../../redux/actions';
import _ from 'lodash';
import { getOffsetTop } from '../../utils';
import { updateUserAddressAndOrderType } from '../../utils/customer-address-and-shops';
import { checkPendingOrderValidity } from '../../api/pendingOrder';

export const getClasses = () => {
  const { isHorizontalSection } = store.getState().componentReducer;
  const listSectionClass = 'col-lg-2 col-4 col-md-3 mb-3 pr-4';
  let listProductClass = 'col-lg-10 col-8 col-md-9';
  if (isHorizontalSection) {
    listProductClass = 'col-12 p-0';
  }
  return { listSectionClass, listProductClass };
};

export const displayOrNotHeader = (displayNavBar: boolean) => {
  const header = document.getElementsByTagName('header')[0];
  if (header) {
    if (displayNavBar) {
      header.style.visibility = 'hidden';
    } else {
      header.style.visibility = 'visible';
    }
  }
};

type UpdateShopFromLink = {
  shopIdFromLink: string;
  customerAddress: any;
  orderType: string;
};

export const updateShopFromLink = async ({
  shopIdFromLink,
  customerAddress,
  orderType,
}: UpdateShopFromLink) => {
  if (customerAddress && shopIdFromLink) {
    store.dispatch(updateShopIsLoaded(false));
    await updateUserAddressAndOrderType(
      shopIdFromLink,
      customerAddress,
      orderType,
    );
  }
};

export const updateDimensions = () => {
  store.dispatch(
    setIsMobile(window.matchMedia('screen and (max-width: 575px)').matches),
  );
  store.dispatch(setNavbarHeight());
  store.dispatch(showHorizontalSection());
};

export const handleScroll = (
  currentListSectionsRef: any,
  displaySectionsNavBar: boolean,
  setDisplaySectionsNavBar: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const { sectionsRef } = store.getState().sectionReducer;
  const { navbarHeight } = store.getState().componentReducer;
  const extraTop = 2;
  const needToDisplaySectionsNavBar =
    currentListSectionsRef &&
    window.scrollY >= currentListSectionsRef.offsetTop - extraTop;
  if (needToDisplaySectionsNavBar && !displaySectionsNavBar) {
    setDisplaySectionsNavBar(true);
  } else if (!needToDisplaySectionsNavBar && displaySectionsNavBar) {
    setDisplaySectionsNavBar(false);
  }
  store.dispatch(setNavbarHeight());

  let offsetTop = 0;
  let newSectionKey = null;
  const isBottomPage =
    window.innerHeight + window.scrollY >= document.body.offsetHeight;
  _.map(sectionsRef, (sectionRef, sectionKey) => {
    if (
      sectionRef &&
      (window.scrollY >=
        getOffsetTop(sectionRef) - parseInt(navbarHeight, 10) - extraTop ||
        isBottomPage) &&
      getOffsetTop(sectionRef) > offsetTop
    ) {
      offsetTop = getOffsetTop(sectionRef);
      newSectionKey = sectionKey;
    }
  });

  if (newSectionKey) {
    store.dispatch(selectSection(newSectionKey));
  }
};

export const verifyPendingOrderValidity = async (): Promise<
  number | boolean
> => {
  try {
    const { message, totalPriceOrder } =
      (await checkPendingOrderValidity()) || {};
    if (message) {
      store.dispatch(showMessageModal(message));
      return false;
    }
    return totalPriceOrder;
  } catch (error) {
    const errorMessage = error?.errorMessage;
    if (errorMessage) {
      store.dispatch(showMessageModal(errorMessage));
    }
    return false;
  }
};
